import React, { ReactNode } from 'react';
import { Modal } from 'antd';
import 'baseComponents/ModalComponent/modalComponent.scss';
import { exhaustiveCheck } from 'utils/exhaustiveCheck';
import warningIcon from 'assets/icons/warningIcon.svg';
type ModalVariant = 'default' | 'warning';
interface Props {
  open: boolean;
  title?: ReactNode;
  apperance?: ModalVariant;
  close: () => void;
}

export const ModalComponent: React.FC<React.PropsWithChildren<Props>> = ({
  open,
  title,
  apperance = 'default',
  close,
  children,
}) => {
  return (
    <Modal
      footer={null}
      title={<TitleWrapper appearance={apperance}>{title}</TitleWrapper>}
      open={open}
      onCancel={close}
    >
      {children}
    </Modal>
  );
};

interface TitleWrapperProps {
  appearance: ModalVariant;
}
const TitleWrapper: React.FC<React.PropsWithChildren<TitleWrapperProps>> = ({
  appearance,
  children,
}) => {
  switch (appearance) {
    case 'default':
      return <>{children}</>;
    case 'warning':
      return (
        <div className='modal-title-warning'>
          <img style={{ width: '35px' }} src={warningIcon} alt='Warning icon' />
          {children}
        </div>
      );
    default:
      return exhaustiveCheck(appearance, 'Unknown Modal Variant');
  }
};
